"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _uiUtils = require("@airasia/ui-utils");

var styles = _crossPlatformComponents.StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "row",
    marginBottom: 15
  },
  reverseContainer: {
    flexDirection: 'row-reverse'
  },
  roomHeader: {
    flex: 1,
    flexDirection: 'row',
    marginTop: 10,
    marginBottom: 2
  },
  modalPopupContainer: {
    flex: 1,
    flexDirection: 'row-reverse',
    web: {
      flexDirection: 'column-reverse'
    },
    position: 'absolute',
    backgroundColor: 'rgba(0,0,0,0.7)',
    height: 0,
    ios: {
      height: '100%',
      alignItems: 'flex-end'
    },
    android: {
      height: '100%',
      alignItems: 'flex-end'
    },
    bottom: 0
  },
  popupContainer: {
    flex: 1
  },
  overlay: {
    web: {
      position: 'fixed',
      overflowY: 'auto'
    },
    width: '100%',
    height: '100%',
    top: 0,
    zIndex: 0,
    flex: 1
  },
  modalPopup: {
    backgroundColor: "white",
    borderColor: "#bfc5cf",
    borderWidth: 1,
    paddingHorizontal: 24,
    width: '100%',
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    web: {
      position: "absolute",
      maxHeight: 'calc(100vh - 100px)'
    },
    overflow: 'scroll'
  },
  modalContainer: {
    paddingVertical: 24
  },
  popup: {
    backgroundColor: "white",
    borderColor: "#bfc5cf",
    borderWidth: 1,
    padding: 20,
    paddingBottom: 9,
    borderRadius: 4,
    width: 392,
    position: "absolute",
    top: 5,
    left: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84
  },
  popupLeftAligned: {
    right: 0,
    left: 'auto'
  },
  line: {
    borderBottomWidth: 1,
    borderBottomColor: "#d9dbe0",
    marginVertical: 10
  },
  buttonContainer: {
    flexDirection: "row",
    marginVertical: 10,
    web: {
      minHeight: 40
    }
  },
  button: {
    width: 120,
    justifyContent: "flex-end",
    web: {
      marginVertical: 0
    }
  },
  selectRoomMessage: {
    backgroundColor: "rgba(201, 67, 24, 0.1)",
    borderColor: "#B73810",
    borderWidth: 1,
    borderRadius: 4,
    marginTop: 2,
    marginBottom: 12,
    paddingVertical: 12,
    paddingHorizontal: 12,
    flex: 1,
    flexDirection: "row"
  },
  selectRoomMessageInner: {
    color: "#C94318",
    fontSize: 12,
    lineHeight: 16
  },
  roomLabel: {
    color: "#212124",
    lineHeight: 22,
    fontSize: 16,
    flex: 1
  },
  link: {
    color: "#4B4FA6",
    lineHeight: 20,
    fontSize: 16,
    fontWeight: '500',
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB
    }
  },
  stepperButtonText: {
    fontSize: 20,
    color: '#4b4fa6',
    textAlign: 'center',
    position: 'relative'
  },
  passengerSelectionContainer: {
    position: "relative",
    zIndex: 10,
    top: 2
  },
  touchable: {
    flexDirection: "row"
  },
  textInputIcon: {
    position: 'relative',
    left: -10
  },
  labelPassenger: {
    fontSize: 14,
    color: "#1d1d1d",
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontWeight: '400',
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB
    }
  }
});

var _default = styles;
exports["default"] = _default;